import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Shirt, Bath, BedDouble } from 'lucide-react';
const zones = [{
  icon: Shirt,
  title: 'Laundry',
  desc: 'Clothes, towels, pajamas, and the residue they carry.'
}, {
  icon: Bath,
  title: 'Bath & Body',
  desc: 'Soap, shampoo, hand soap, and lotions.'
}, {
  icon: BedDouble,
  title: 'Bedding/Bedroom',
  desc: 'Sheets, blankets, stuffed animals, and sleep surfaces.'
}];
export function ProblemSection() {
  return <section className="py-20 px-6 bg-white" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2D2D] mb-8 text-center" data-id="element-114">
            Here's the uncomfortable truth
          </h2>
          <div className="bg-[#F5F1E8] rounded-xl p-8 md:p-10 border-l-4 border-[#D4A59A]" data-id="element-115">
            <p className="text-xl text-[#4A4A4A] leading-relaxed mb-6" data-id="element-116">
              Most families don't fail because they picked the "wrong" lotion.
            </p>
            <p className="text-xl text-[#4A4A4A] leading-relaxed font-medium" data-id="element-117">
              They fail because{' '}
              <span className="text-[#D4A59A]" data-id="element-118">
                fragrance exposure is happening in the highest-contact zones
              </span>{' '}
              over and over—so the trigger never actually leaves the system.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-119">
          {zones.map((zone, index) => <motion.div key={zone.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center p-6 rounded-2xl bg-white border border-[#E5E5E5] hover:border-[#8B9D83]/30 hover:shadow-lg hover:shadow-[#8B9D83]/5 transition-all" data-id="element-120">
              <div className="w-16 h-16 mx-auto bg-[#F5F1E8] rounded-full flex items-center justify-center mb-4 text-[#8B9D83]" data-id="element-121">
                <zone.icon className="w-8 h-8" data-id="element-122" />
              </div>
              <h3 className="text-xl font-serif font-semibold text-[#2D2D2D] mb-2" data-id="element-123">
                {zone.title}
              </h3>
              <p className="text-[#5A5A5A]" data-id="element-124">{zone.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-2xl mx-auto" data-id="element-125">
          <p className="text-lg text-[#4A4A4A] mb-4" data-id="element-126">
            If even one of these zones stays fragranced—or keeps detergent
            residue—your child can keep getting re-exposed without you realizing
            it.
          </p>
          <div className="flex items-center justify-center gap-2 text-[#D4A59A] font-serif text-xl italic" data-id="element-127">
            <AlertCircle className="w-5 h-5" data-id="element-128" />
            <span data-id="element-129">That's why it feels random.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}